<template>
    <div>
        <!-- <v-card 
            flat
        >
            <v-card-text>
               
            </v-card-text>
        </v-card> -->

        <v-layout justify-center>
           
            <v-card-actions>
                <p id="title">{{ title }}</p>
            </v-card-actions>
        </v-layout>
    </div>
</template>

<script>
// import Test2 from './Test2';

// export default {
//     components: {
//         Test2,
//     },
//     name: 'Test',

//     data: () => ({
//         tab: "about",
//     }),
// }

export default {
    name: 'Title',
    props: {
        title: {
            type: String,
            default: () => {
                return {
                    title: null
                }
            }
        },
    },
    created() {
        // console.log(this.msg);
    }
}
</script>

<style scoped>
#title {
    font-size: 20px;
    /* text-align: center; */
    text-decoration: underline;
}

</style>
